import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';

import { CAMPAIGN_OWNER, CAMPAIGN_ADMIN, TEAM_MEMBER, CLIENT, INFLUENCER } from '../../utils/static-configuration';
import { setStatusBar, clearStatusBar } from '../../containers/status-bar/actions';
import { checkUserIsTeamMember, checkUserHasAdminRights } from '../../utils/role-service';
import CampaignInvite from '../../containers/campaign-new/campaign-invite';
import Member from '../../components/member';

class CampaignMembers extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  componentDidMount() {
    // Users must navigate to this page from a valid campaign
    const campaignExist = this.props.campaign.size > 0;
    if (!campaignExist) {
      this.context.router.push('/');
    }
  }

  componentWillUnmount() {
    // Reset status bar
    this.props.onClearStatusBar();
  }

  render() {
    const { myUserRole, campaign, members, pendingInvitations } = this.props;

    const campaignName = campaign.get('name');
    const campaignId = campaign.get('id');

    const teamMembers = [];
    const clientMembers = [];
    const influencerMembers = [];
    const memberEmails = [];
    const pendingMemberEmails = [];

    if (members) {
      members.forEach(member => {
        const email = member.get('email');
        const role = member.get('role');

        memberEmails.push(email);
        if (role === TEAM_MEMBER || role === CAMPAIGN_OWNER || role === CAMPAIGN_ADMIN) teamMembers.push(member);
        if (role === CLIENT) clientMembers.push(member);
        if (role === INFLUENCER) influencerMembers.push(member);
      });
    }

    if (pendingInvitations.size > 0) {
      pendingInvitations.forEach(organisation => organisation.forEach(member => {
        const email = member.get('email');
        pendingMemberEmails.push(email);
      }));
    }

    const isUserTeamMember = checkUserIsTeamMember(myUserRole);
    const isUserAnAdmin = checkUserHasAdminRights(myUserRole);

    return (
      <div className="page">
        <div className="page-content">
          <div className="grid">
            <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
              <div className="breadcrumb-bar">
                <img src="/icons/chevron-left.svg" alt="back to campaign" onClick={() => this.context.router.push(`/campaign/${campaignId}`)} />
                <h3 onClick={() => this.context.router.push(`/campaign/${campaignId}`)}>
                  {campaignName}
                </h3>
              </div>
            </div>
            { isUserTeamMember &&
              <div className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6">
                <div className="hero left">
                  <h1>Invite people</h1>
                </div>
              </div>
            }
            { isUserAnAdmin &&
              <div className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6">
                <div className="hero action right">
                  <button className="medium icon" onClick={() => this.context.router.push('/campaign/members/manage')}>
                    <p>Manage people</p>
                    <img src="/icons/settings.svg" alt="Manage people" />
                  </button>
                </div>
              </div>
            }
            { isUserTeamMember &&
              <CampaignInvite
                campaignId={campaignId}
                campaignName={campaignName}
                memberEmails={memberEmails}
                pendingMemberEmails={pendingMemberEmails}
              />
            }
            <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
              { isUserTeamMember &&
                <div>
                  <div className="spacer" />
                  <div className="break" />
                </div>
              }
              <div className="hero left">
                <h2>On this campaign</h2>
              </div>
            </div>

            { teamMembers.length > 0 &&
              <span>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3>Team ({teamMembers.length})</h3>
                </div>
                { teamMembers.map(member => (
                  <Member
                    key={member.get('id')}
                    member={member}
                    deletable={false}
                  />
                  ))}
              </span>
            }
            { clientMembers.length > 0 &&
              <span>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="spacer" />
                </div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3>Clients ({clientMembers.length})</h3>
                </div>
                { clientMembers.map(member => (
                  <Member
                    key={member.get('id')}
                    member={member}
                    deletable={false}
                  />
                  ))}
              </span>
            }
            { influencerMembers.length > 0 &&
              <span>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="spacer" />
                </div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3>Influencers ({influencerMembers.length})</h3>
                </div>
                { influencerMembers.map(member => (<Member key={member.get('id')} member={member} deletable={false} />))}
              </span>}
            { pendingInvitations.size > 0 &&
              <span>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <div className="spacer" />
                </div>
                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3>Pending invites ({pendingInvitations.size})</h3>
                </div>
                { pendingInvitations.map(organisation => organisation.map(member => (
                  <Member key={member.get('id')} member={member} pendingInvites deletable={false} pendingInviteUrl={member.get('link')} />
                    )))}
              </span>
            }
          </div>
        </div>
      </div>
    );
  }
}

CampaignMembers.propTypes = {
  routeParams: React.PropTypes.object,
};

const mapStateToProps = state => ({
  campaign: state.campaign.get('campaign'),
  members: state.members.get('members'),
  pendingInvitations: state.members.get('pendingInvitations'),
  myUserRole: state.campaign.get('myUserRole'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetStatusBar: (message, colour) => dispatch(setStatusBar(message, colour)),
    onClearStatusBar: () => dispatch(clearStatusBar()),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignMembers);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-members/index.js
 **/